"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinningOfferDtoSignatureStatusEnum = exports.WinningOfferDtoStatusEnum = void 0;
exports.instanceOfWinningOfferDto = instanceOfWinningOfferDto;
exports.WinningOfferDtoFromJSON = WinningOfferDtoFromJSON;
exports.WinningOfferDtoFromJSONTyped = WinningOfferDtoFromJSONTyped;
exports.WinningOfferDtoToJSON = WinningOfferDtoToJSON;
exports.WinningOfferDtoToJSONTyped = WinningOfferDtoToJSONTyped;
var GetOfferPartyDto_1 = require("./GetOfferPartyDto");
var GetPaymentReceiptDto_1 = require("./GetPaymentReceiptDto");
/**
 * @export
 */
exports.WinningOfferDtoStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * @export
 */
exports.WinningOfferDtoSignatureStatusEnum = {
    OfferorSignPending: 'offeror_sign_pending',
    OfferorSigned: 'offeror_signed',
    OffereeSignPending: 'offeree_sign_pending',
    OffereeSigned: 'offeree_signed'
};
/**
 * Check if a given object implements the WinningOfferDto interface.
 */
function instanceOfWinningOfferDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('buyers' in value) || value['buyers'] === undefined)
        return false;
    if (!('sellers' in value) || value['sellers'] === undefined)
        return false;
    return true;
}
function WinningOfferDtoFromJSON(json) {
    return WinningOfferDtoFromJSONTyped(json, false);
}
function WinningOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'signatureStatus': json['signatureStatus'],
        'acceptedAt': json['acceptedAt'] == null ? undefined : json['acceptedAt'],
        'rejectedAt': json['rejectedAt'] == null ? undefined : json['rejectedAt'],
        'rejectedReason': json['rejectedReason'] == null ? undefined : json['rejectedReason'],
        'settlementDate': json['settlementDate'] == null ? undefined : json['settlementDate'],
        'depositAmount': json['depositAmount'] == null ? undefined : json['depositAmount'],
        'offerPrice': json['offerPrice'],
        'createdAt': json['createdAt'],
        'buyers': (json['buyers'].map(GetOfferPartyDto_1.GetOfferPartyDtoFromJSON)),
        'sellers': (json['sellers'].map(GetOfferPartyDto_1.GetOfferPartyDtoFromJSON)),
        'paymentSummary': json['paymentSummary'] == null ? undefined : (0, GetPaymentReceiptDto_1.GetPaymentReceiptDtoFromJSON)(json['paymentSummary']),
    };
}
function WinningOfferDtoToJSON(json) {
    return WinningOfferDtoToJSONTyped(json, false);
}
function WinningOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
        'signatureStatus': value['signatureStatus'],
        'acceptedAt': value['acceptedAt'],
        'rejectedAt': value['rejectedAt'],
        'rejectedReason': value['rejectedReason'],
        'settlementDate': value['settlementDate'],
        'depositAmount': value['depositAmount'],
        'offerPrice': value['offerPrice'],
        'createdAt': value['createdAt'],
        'buyers': (value['buyers'].map(GetOfferPartyDto_1.GetOfferPartyDtoToJSON)),
        'sellers': (value['sellers'].map(GetOfferPartyDto_1.GetOfferPartyDtoToJSON)),
        'paymentSummary': (0, GetPaymentReceiptDto_1.GetPaymentReceiptDtoToJSON)(value['paymentSummary']),
    };
}
